import React from 'react';

import classNames from 'classnames'

import './style.scss'

const Alert = ({ className, message, link }) => {
  const cn = classNames('Alert', className)
  return(
    <div className={cn}>
      <span dangerouslySetInnerHTML={{ __html: message }} />
      {link ? <span>Обратитесь в <a style={{color: 'inherit'}} href="https://zenit.win/company/support" target="_blank" rel="noreferrer">ТП БК</a></span> : null}
    </div>
  )
}

export default Alert;